'use strict';

module.exports = {
  SOUNDCLOUD_CLIENT_ID: '1679645537cdb5235f979658aafd10d8',
  SENTRY_URL: 'https://7d9ffb4b43494acabf3488e4ee30e368@app.getsentry.com/3729',
  RE_CAPTCHA_SITEKEY: process.env.NODE_ENV === 'production'
    ? '6Ld8ZykTAAAAALe9eOsFqq-F1Q9eHzhAOoUmEJb8'
    : '6LcTlykTAAAAAH8PE_QWHR2ytM5WtQm1KlG-nka2'
};



/** WEBPACK FOOTER **
 ** ./constants/ApiKeys.js
 **/